import {
  NavigationAction,
  NavigationProp,
  NavigationState,
} from "@react-navigation/native";
import { StackScreenProps } from "@react-navigation/stack";
import { View, Text, ScrollView, Image, TouchableOpacity } from "react-native";
import navigationNames from "../../../navigation/navigationNames";
import ButtonIcon from "../../../shared-components/buttons/ButtonIcon";
import ButtonPrimary from "../../../shared-components/buttons/ButtonPrimary";
import TextPrimary from "../../../shared-components/text/TextPrimary";
import * as Linking from "expo-linking";
import TextButtonPrimary from "../../../shared-components/buttons/TextButtonPrimary";
import GooglePlayButton from "../../../assets/badges/google-play-badge.png";
import AppStoreButton from "../../../assets/badges/app-store-badge-coming-soon.png";
import Footer from "../../../shared-components/Footer";

const HomePage = ({ route, navigation }: any) => {
  return (
    <ScrollView
      contentContainerStyle={{
        padding: 16,
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100%",
      }}
    >
      <Image
        source={require("../../../assets/icons/juta-app-icon.png")}
        style={{
          width: 256,
          height: 256,
        }}
      />
      <View
        style={{
          padding: 16,
          alignItems: "center",
        }}
      >
        <TextPrimary
          label="Juta"
          textStyle={{
            fontSize: 36,
            fontWeight: "bold",
          }}
        />
        <TextPrimary
          label="Your Personal Finance Tracker"
          textStyle={{
            fontSize: 24,
          }}
        />
      </View>
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <View
          style={{
            paddingVertical: 16,
            paddingHorizontal: 8,
          }}
        >
          <TouchableOpacity
            onPress={() => {
              Linking.openURL(
                "https://play.google.com/store/apps/details?id=app.juta"
              );
            }}
          >
            <Image
              source={GooglePlayButton}
              style={{
                width: 256,
                height: 72,
              }}
            />
          </TouchableOpacity>
        </View>
        <View
          style={{
            paddingVertical: 16,
            paddingHorizontal: 8,
          }}
        >
          <Image
            source={AppStoreButton}
            style={{
              aspectRatio: 260 / 80,
              width: 260 * (72 / 80),
              height: 72,
            }}
          />
        </View>
      </View>
      <TouchableOpacity
        onPress={() => {
          Linking.openURL(
            "https://www.producthunt.com/posts/juta?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-juta"
          );
        }}
      >
        <Image
          source={{
            uri: "https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=381297&theme=light",
          }}
          style={{
            width: 256,
            height: 54,
            overflow: "visible",
          }}
        />
      </TouchableOpacity>
      <Footer
        onPress={(id: string) => {
          navigation.navigate(id);
        }}
      />
    </ScrollView>
  );
};

export default HomePage;
